import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type ProgressIndexCircleProps = {
  label: ReactNode;
  value: number;
  isCompleted?: boolean;
  size?: number | string;
  thickness?: number;
};

export function ProgressIndexCircle({
  label,
  value,
  isCompleted = false,
  size = "2rem",
  thickness = 3
}: ProgressIndexCircleProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  const normalizedValue = Math.min(100, Math.max(0, value));
  const displayedValue = isCompleted ? 100 : normalizedValue;

  return (
    <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center">
      <CircularProgress
        variant="determinate"
        value={ 100 }
        size={ size }
        thickness={ thickness }
        aria-hidden="true"
        sx={ {
          color: theme.customColors.border,
          position: "absolute"
        } }
      />
      <CircularProgress
        variant="determinate"
        value={ displayedValue }
        aria-label={ `${t("completion_percentage")} ${displayedValue}%` }
        size={ size }
        thickness={ thickness }
        sx={ {
          color: isCompleted || normalizedValue > 0
            ? theme.customColors.borderSecondaryComplete
            : "transparent"
        } }
      />
      <Box
        position="absolute"
        top={ 0 }
        right={ 0 }
        bottom={ 0 }
        left={ 0 }
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          component="span"
          fontWeight={ 600 }
          fontSize="1rem"
          color={ theme.customColors.exploreCardText }
          lineHeight={ 1 }
        >
          { label }
        </Typography>
      </Box>
    </Box>
  );
}


